export function capitalizeFirstLetter (str) {
  if (!str || str.trim() === "") return "s/n"; // Retorna "-" si está vacío o es solo espacios
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};